import {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from 'vue-router';

const projectRoutes: Array<RouteRecordRaw> = [
  {
    path: 'projects',
    component: () =>
      import(
        '@/app/project/components/project-list/projects-index-component.vue'
      ),
    name: 'app.projects',
  },
  {
    path: 'project/:projectId',
    component: () =>
      import(
        '@/app/project/components/project-show/project-show-component.vue'
      ),
    name: 'app.project',
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ): void => {
      const projectId = to.params.projectId;
      next({ name: 'app.project.tasks', params: { projectId: projectId } });
    },
  },
  {
    path: '',
    component: () =>
      import(
        '@/app/project/components/project-show/project-show-component.vue'
      ),
    children: [
      {
        path: 'project/:projectId/tasks/:taskId?',
        component: () =>
          import('@/app/project-task/components/project-tasks-component.vue'),
        name: 'app.project.tasks',
      },
      {
        path: 'project/:projectId/details',
        component: () =>
          import(
            '@/app/project/components/project-show/project-details-component.vue'
          ),
        name: 'app.project.details',
      },
      {
        path: 'project/:projectId/finance',
        component: () =>
          import(
            '@/app/project-finance/components/project-finance-component.vue'
          ),
        name: 'app.project.finance',
      },
      {
        path: 'project/:projectId/notifications',
        component: () =>
          import(
            '@/app/project/components/project-show/project-user-notifications-overrides-component.vue'
          ),
        name: 'app.project.notifications',
      },
    ],
  },
];

export default projectRoutes;
